import { images } from "../../constants";
import Card from "react-bootstrap/Card";
import { useLocation, useNavigate } from "react-router-dom";
import { Col } from "react-bootstrap";
import { Row } from "react-bootstrap";
import BackArrow from "../backArrow";
import { Formik, Form } from "formik";
import ClearIcon from "@mui/icons-material/Clear";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useRef, useState, useEffect } from "react";
import * as Yup from "yup";
import LocationModal from "../locationmodal/LocationModal";
import "./form.css";
import { getAsset } from "../../helpers/helper";
import { useSelector } from "react-redux";
import TermsModal from "../modals/TermsModal";

const CreateForm = ({
  CreateHandler,
  butn,
  id,
  setCreateShop,
  back,
  title,
  link,
  UpdateShop,
  createShop,
  shopCategoryone,
  Buttn,
  dataHandler,
  cancleurl,
  getInputProps,
  getRootProps,
  displayimg,
  setDisplayimg,
  Shopdatas,
  isUploading,
  uploadProgress,
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  // Refs for input fields
  const shopnameRef = useRef(null);
  const marketPlaceRef = useRef(null);
  const shoplicenseRef = useRef(null);
  const shopaddressRef = useRef(null);
  const descriptionRef = useRef(null);
  const shopCategorySelectRef = useRef(null);

  const openShopCategorySelect = () => {
    const select = shopCategorySelectRef.current;
    if (!select) return;

    if (typeof select.showPicker === "function") {
      try {
        select.showPicker();
        return;
      } catch {
        // Fall back to a normal select click if the browser blocks showPicker.
      }
    }

    select.focus();
    select.click();
  };

  const ShopHandler = (event) => {
    setCreateShop((prevState) => ({
      ...prevState,
      [event.target.name]: event.target.value,
    }));
  };

  const { name: currentUser } = useSelector((state) => state.user);
  const userCountry = currentUser?.address?.country || "";
  const userCity = currentUser?.MCity || currentUser?.address?.city;

  const validationSchema = Yup.object({
    shopname: Yup.string().required("shopname is required*"),
    shopCategory: Yup.string().required("shopCategory is required*"),
    marketPlace: Yup.string().required("Market Place is required*"),
    shoplicense: Yup.string()
      .test(
        "shoplicense-validation",
        "Invalid CNIC or Licence Number",
        function (value) {
          const { path, createError } = this;
          if (!value)
            return createError({ path, message: "shoplicense is required*" });

          if (userCountry.toLowerCase() === "pakistan") {
            const cnicRegex = /^(\d{13}|\d{5}-\d{7}-\d{1})$/;
            if (!cnicRegex.test(value)) {
              return createError({
                path,
                message:
                  "Invalid Pakistani CNIC. Format: 13 digits or XXXXX-XXXXXXX-X",
              });
            }
          } else {
            if (value.length < 5) {
              return createError({
                path,
                message:
                  "Invalid Licence Number. Minimum 5 characters required",
              });
            }
          }
          return true;
        },
      )
      .required("shoplicense is required*"),
    shopaddress: Yup.string().required("shopaddress is required*"),
    description: Yup.string().required("description is required*"),
  });
  const [mshow, setMshow] = useState(false);
  const [showTermsModal, setShowTermsModal] = useState(false);
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [termsError, setTermsError] = useState(false);

  const handleClose = () => setMshow(false);
  const handleShow = () => setMshow(true);

  const removeImage = (index) => {
    const updatedImages = [...displayimg];
    updatedImages.splice(index, 1);
    setDisplayimg(updatedImages);
  };

  // Clear input fields on mount to prevent autofill
  useEffect(() => {
    if (shopnameRef.current)
      shopnameRef.current.value = createShop?.shopname || "";
    if (marketPlaceRef.current)
      marketPlaceRef.current.value = createShop?.marketPlace || "";
    if (shoplicenseRef.current)
      shoplicenseRef.current.value = createShop?.shoplicense || "";
    if (shopaddressRef.current)
      shopaddressRef.current.value = createShop?.shopaddress || "";
    if (descriptionRef.current)
      descriptionRef.current.value = createShop?.description || "";
  }, [createShop]);

  return (
    <>
      <TermsModal show={showTermsModal} onClose={() => setShowTermsModal(false)} formTitle={title} />
      <LocationModal
        mshow={mshow}
        handleClose={handleClose}
        userCity={userCity}
        createShop={createShop}
        setCreateShop={setCreateShop}
      />
      <Row>
        <Formik
          enableReinitialize={true}
          initialValues={{
            shopname: createShop?.shopname || "",
            shopCategory: createShop?.shopCategory || "",
            shoplicense: createShop?.shoplicense || "",
            shopaddress: createShop?.shopaddress || "",
            marketPlace: createShop?.marketPlace || "",
            description: createShop?.description || "",
          }}
          validateOnBlur={false}
          validationSchema={validationSchema}
          onSubmit={(values) => {
            if (!termsAccepted) { setTermsError(true); return; }
            setTermsError(false);
            const mockEvent = { preventDefault: () => {} };
            if (butn === "Create") {
              CreateHandler(mockEvent);
            } else {
              UpdateShop(mockEvent);
            }
          }}
        >
          {({
            handleChange,
            handleBlur,
            handleSubmit,
            errors,
            touched,
            isValid,
            dirty,
          }) => (
            <Form
              autoComplete="off" // Disable autofill for the form
              onSubmit={handleSubmit}
            >
              {/* Hidden input to trick autofill */}
              <input
                type="text"
                style={{ display: "none" }}
                autoComplete="off"
              />
              <div className="screenHeight createFormScreen d-flex justify-content-center align-items-center">
                <div className="Form-Shadow createFormCard col-12 col-sm-9 col-md-7 col-lg-6 pb-3">
                  <div className="arrowback">
                    <BackArrow back={back} black="black" mystyle="ps-4 p-1" />
                  </div>
                  <div className="createFormContent pt-1">
                    <div className="pt-4">
                      <h4 className="createHeading">{title}</h4>
                    </div>
                    <div className="row">
                      <div className="d-flex flex-column pt-3 col-lg-6 col-md-6 col-12 pe-lg-2 pe-md-2">
                        <label className="custm-lble-2 pb-2">Shop Name</label>
                        {location.pathname === `${link}${id}` ? (
                          <input
                            style={{ color: "black" }}
                            defaultValue={createShop?.shopname}
                            name="shopname" // Non-standard name
                            onChange={(e) => {
                              ShopHandler(e);
                              handleChange(e);
                            }}
                            className="input-style"
                            placeholder="Name"
                            onBlur={handleBlur}
                            disabled
                            autoComplete="off"
                            ref={shopnameRef}
                            onFocus={(e) => {
                              if (!createShop?.shopname) e.target.value = "";
                            }}
                          />
                        ) : (
                          <input
                            style={{ color: "black" }}
                            defaultValue={createShop?.shopname}
                            name="shopname" // Non-standard name
                            onChange={(e) => {
                              ShopHandler(e);
                              handleChange(e);
                            }}
                            className="input-style"
                            placeholder="Name"
                            onBlur={handleBlur}
                            autoComplete="off"
                            ref={shopnameRef}
                            onFocus={(e) => {
                              if (!createShop?.shopname) e.target.value = "";
                            }}
                          />
                        )}
                        {errors.shopname && touched.shopname ? (
                          <div>
                            <p className="error_text_color">
                              {errors.shopname}
                            </p>
                          </div>
                        ) : null}
                      </div>
                      <div className="d-flex flex-column pt-3 col-lg-6 col-md-6 col-12 pe-lg-2 pe-md-2">
                        <label className="custm-lble-2 pb-2">
                          Select Shop Category
                        </label>
                        <div className="selectdiv shopCategorySelect">
                          <label>
                            <select
                              ref={shopCategorySelectRef}
                              name="shopCategory" // Non-standard name
                              placeholder="Select Category"
                              style={{ color: "black" }}
                              className=""
                              onChange={(e) => {
                                handleChange(e);
                                Shopdatas(e);
                              }}
                              onBlur={handleBlur}
                              autoComplete="off"
                            >
                              <option value="">Select Category</option>
                              {shopCategoryone?.map((category) => (
                                <option
                                  key={category._id}
                                  value={`${category?._id}.${category?.name}`}
                                >
                                  {category?.name}
                                </option>
                              ))}
                            </select>
                          </label>
                          <button
                            type="button"
                            className="shopCategorySelectArrow"
                            aria-label="Open shop category options"
                            onClick={openShopCategorySelect}
                          >
                            <KeyboardArrowDownIcon fontSize="small" />
                          </button>
                        </div>
                        {errors.shopCategory && touched.shopCategory ? (
                          <div>
                            <p className="error_text_color">
                              {errors.shopCategory}
                            </p>
                          </div>
                        ) : null}
                      </div>
                    </div>
                    <div className="row">
                      <div className="d-flex flex-column pt-3 col-lg-6 col-md-6 col-12 pe-lg-2 pe-md-2">
                        <label className="custm-lble-2 pb-2">
                          Market Place
                        </label>
                        <input
                          style={{ color: "black" }}
                          name="marketPlace" // Non-standard name
                          className="input-style"
                          placeholder="Market Place"
                          onChange={(e) => {
                            ShopHandler(e);
                            handleChange(e);
                          }}
                          onBlur={handleBlur}
                          autoComplete="off"
                          ref={marketPlaceRef}
                          onFocus={(e) => {
                            if (!createShop?.marketPlace) e.target.value = "";
                          }}
                        />
                        <small className="marketPlaceHelper">
                          Select the local market or commercial where your shop is located.
                        </small>
                        {errors.marketPlace && touched.marketPlace ? (
                          <div>
                            <p className="error_text_color cursor_P">
                              {errors.marketPlace}
                            </p>
                          </div>
                        ) : null}
                      </div>
                      <div className="d-flex flex-column pt-3 col-lg-6 col-md-6 col-12 ps-2">
                        <label className="custm-lble-2 pb-2">
                          {userCountry.toLowerCase() === "pakistan"
                            ? "CNIC Number / Licence Number*"
                            : "Licence Number*"}
                        </label>
                        {location.pathname === `${link}${id}` ? (
                          <input
                            style={{ color: "black" }}
                            defaultValue={createShop?.shoplicense}
                            name="shoplicense" // Non-standard name
                            onChange={(e) => {
                              ShopHandler(e);
                              handleChange(e);
                            }}
                            className="input-style"
                            placeholder={
                              userCountry.toLowerCase() === "pakistan"
                                ? "e.g. 37405-1234567-1"
                                : "Licence Number"
                            }
                            onBlur={handleBlur}
                            disabled
                            autoComplete="off"
                            ref={shoplicenseRef}
                            onFocus={(e) => {
                              if (!createShop?.shoplicense) e.target.value = "";
                            }}
                          />
                        ) : (
                          <input
                            style={{ color: "black" }}
                            defaultValue={createShop?.shoplicense}
                            name="shoplicense" // Non-standard name
                            onChange={(e) => {
                              ShopHandler(e);
                              handleChange(e);
                            }}
                            className="input-style"
                            placeholder={
                              userCountry.toLowerCase() === "pakistan"
                                ? "e.g. 37405-1234567-1"
                                : "Licence Number"
                            }
                            onBlur={handleBlur}
                            autoComplete="off"
                            ref={shoplicenseRef}
                            onFocus={(e) => {
                              if (!createShop?.shoplicense) e.target.value = "";
                            }}
                          />
                        )}
                        {errors.shoplicense && touched.shoplicense ? (
                          <div>
                            <p className="error_text_color">
                              {errors.shoplicense}
                            </p>
                          </div>
                        ) : null}
                      </div>
                    </div>
                    <div className="row">
                      <div className="d-flex flex-column pt-lg-3 pt-3 col-12">
                        <label className="custm-lble-2 pb-2">
                          Shop Address
                        </label>
                        <input
                          defaultValue={createShop?.shopaddress}
                          name="shopaddress" // Non-standard name
                          onChange={(e) => {
                            ShopHandler(e);
                            handleChange(e);
                          }}
                          className="input-style"
                          placeholder="Add Address with maps"
                          onBlur={handleBlur}
                          style={{ color: "black" }}
                          autoComplete="off"
                          ref={shopaddressRef}
                          onFocus={(e) => {
                            if (!createShop?.shopaddress) e.target.value = "";
                          }}
                        />
                        <div className="position-relative">
                          <img
                            onClick={handleShow}
                            className="iMg cursor_P"
                            src={images.FindClinic}
                            alt=""
                          />
                        </div>
                        {errors.shopaddress && touched.shopaddress ? (
                          <div>
                            <p className="error_text_color">
                              {errors.shopaddress}
                            </p>
                          </div>
                        ) : null}
                      </div>
                    </div>
                    <div>
                      <div className="d-flex flex-column pt-2">
                        <label className="custm-lble-2 pb-2">Description</label>
                        <textarea
                          style={{ color: "black" }}
                          defaultValue={createShop?.description}
                          name="description" // Non-standard name
                          onChange={(e) => {
                            ShopHandler(e);
                            handleChange(e);
                          }}
                          placeholder="Description"
                          className="input-style pt-1 ps-2 pb-5 pe-2"
                          onBlur={handleBlur}
                          autoComplete="off"
                          ref={descriptionRef}
                          onFocus={(e) => {
                            if (!createShop?.description) e.target.value = "";
                          }}
                        />
                        {errors.description && touched.description ? (
                          <div>
                            <p className="error_text_color">
                              {errors.description}
                            </p>
                          </div>
                        ) : null}
                      </div>
                    </div>
                    {/* Image Upload Section */}
                    <Col>
                      <Row>
                        <Col lg="9" className="me-auto">
                          <Row>
                            <Col lg={3} className="mt-2 ms-1">
                              <Card
                                style={{
                                  width: "6rem",
                                  height: "6rem",
                                  position: "relative", // ✅ to position loader
                                  overflow: "hidden",
                                }}
                                {...getRootProps()}
                                className="dropzone"
                              >
                                {/* Show loader if uploading */}
                                {isUploading ? (
                                  <div
                                    style={{
                                      position: "absolute",
                                      inset: 0,
                                      background: "rgba(255,255,255,0.7)",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      flexDirection: "column",
                                      borderRadius: "0.5rem",
                                    }}
                                  >
                                    <div
                                      className="spinner-border text-primary"
                                      style={{
                                        width: "1.5rem",
                                        height: "1.5rem",
                                      }}
                                      role="status"
                                    ></div>
                                    <small className="mt-1">
                                      {uploadProgress}%
                                    </small>
                                  </div>
                                ) : (
                                  <>
                                    <Card.Img
                                      className="imet-fit"
                                      src={images.AddImage}
                                    />
                                    <Card.Body>
                                      <input
                                        type="file"
                                        id="file"
                                        style={{ display: "none" }}
                                        {...getInputProps()}
                                        multiple
                                        autoComplete="off"
                                      />
                                    </Card.Body>
                                  </>
                                )}
                              </Card>
                            </Col>

                            {displayimg?.length > 0 && (
                              <Col
                                lg={7}
                                className="uploadedShopImages mt-1 d-flex"
                              >
                                {displayimg.map((image, index) => (
                                  <Card
                                    key={index}
                                    className="me-2 mt-1"
                                    style={{
                                      width: "6rem",
                                      height: "6rem",
                                      border: "2px solid",
                                      position: "relative",
                                    }}
                                  >
                                    <Card.Img
                                      className="imet-fit upload-img mt-0"
                                      src={getAsset(image)}
                                      alt=""
                                      crossOrigin="anonymous"
                                      style={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                      }}
                                    />
                                    <div
                                      className="close-btnone text-white"
                                      onClick={() => removeImage(index)}
                                    >
                                      <ClearIcon />
                                    </div>
                                  </Card>
                                ))}
                              </Col>
                            )}
                          </Row>
                        </Col>
                      </Row>
                    </Col>

                    <div className="mt-3 mb-2 ps-1">
                       <div className="d-flex align-items-center gap-2">
                         <input
                           type="checkbox"
                           id="terms-checkbox-createform"
                           checked={termsAccepted}
                           onChange={(e) => { setTermsAccepted(e.target.checked); if(e.target.checked) setTermsError(false); }}
                           style={{ cursor: "pointer", width: "16px", height: "16px", flexShrink: 0 }}
                         />
                         <label htmlFor="terms-checkbox-createform" style={{ margin: 0, fontSize: "0.85rem", cursor: "pointer" }}>
                           I agree to the{" "}
                           <span
                             onClick={(e) => { e.preventDefault(); setShowTermsModal(true); }}
                             style={{ color: "#0d6efd", textDecoration: "underline", cursor: "pointer" }}
                           >
                             Terms &amp; Conditions
                           </span>
                         </label>
                       </div>
                       {termsError && (
                         <p className="error_text_color" style={{ fontSize: "0.8rem", marginTop: "4px", marginBottom: 0 }}>
                           Please agree to the Terms &amp; Conditions before continuing.
                         </p>
                       )}
                     </div>
                     <div className="btns pb-3">
                      <button
                        type="button"
                        className="btn1"
                        onClick={() => navigate(-1)}
                      >
                        Cancel
                      </button>
                      <button className="btn2" type="submit">
                        {butn}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </Row>
    </>
  );
};

export default CreateForm;
